/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Download_Excel_FileInputs */

const en_download_excel_file = /** @type {(inputs: Download_Excel_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Excel file`)
};

const nl_download_excel_file = /** @type {(inputs: Download_Excel_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Excel-bestand`)
};

/**
* | output |
* | --- |
* | "Download Excel file" |
*
* @param {Download_Excel_FileInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const download_excel_file = /** @type {((inputs?: Download_Excel_FileInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Download_Excel_FileInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_download_excel_file(inputs)
	return en_download_excel_file(inputs)
});